export const addFile = file => ({ type: 'ADD_FILE', file })
export const clearFiles = () => ({ type: 'CLEAR_FILES' })
